var _circle, _g, _g2, _circle2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurundi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#f0f0f0",
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m411.876 52.902c-91.652-70.526-220.1-70.526-311.752-.001l155.876 155.876z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.998 303.224-155.874 155.874c91.652 70.526 220.1 70.526 311.752 0l-155.876-155.876z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#6da544"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m208.777 256-155.875-155.876c-70.526 91.652-70.526 220.1 0 311.752z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.224 256 155.874 155.876c70.526-91.652 70.526-220.1 0-311.752z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#f0f0f0",
    r: 111.304
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#d80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 178.087 9.639 16.696h19.279l-9.64 16.695 9.64 16.696h-19.279l-9.639 16.696-9.639-16.696h-19.278l9.639-16.696-9.639-16.695h19.278z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.005 256 9.639 16.696h19.278l-9.639 16.695 9.639 16.696h-19.278l-9.639 16.696-9.64-16.696h-19.278l9.639-16.696-9.639-16.695h19.278z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.996 256 9.639 16.696h19.278l-9.639 16.695 9.639 16.696h-19.278l-9.639 16.696-9.64-16.696h-19.278l9.639-16.696-9.639-16.695h19.278z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null)), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurundi);
export default __webpack_public_path__ + "static/media/burundi.747d8bde648d76784ae32cdbdcfe5949.svg";
export { ForwardRef as ReactComponent };